import { DraggableItem } from "./types";

export const findNodeById = (items: DraggableItem[], id: string): DraggableItem | undefined => {
  for (const node of items) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findNodeById(node.children, id);
      if (found) return found;
    }
  }
  return undefined;
};

export const MAX_VISIBLE_LEVELS = 5;